module.exports = __webpack_public_path__ + "img/Chicken Burger.5bdcdb08.png";